import strFunc from "@/lib/lyg/string";

function RowArea(props: any) {
  let myProps = {
    info: null,
    go_add_use_by_ajax: (inData: any) => { },
    ...props
  };

  let info = myProps.info;
  let word_cnt = 0;
  if (info.cg_word_arr) {
    word_cnt = strFunc.comma(info.cg_word_arr.length);
  }

  let is_pre_exist = false;
  let use_info = null;
  if (info.use_arr && info.use_arr.length > 0) {
    is_pre_exist = true;
    use_info = info.use_arr[0];
  }

  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 p-6 border border-gray-100">
      <div className="mb-4">
        <h3 className="text-lg font-bold text-gray-800 mb-2">{info.a_title}</h3>
        <div className="flex items-center gap-2">
          <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${info.a_word_type == "word"
            ? "bg-blue-100 text-blue-700"
            : "bg-purple-100 text-purple-700"
            }`}>
            {info.a_word_type == "word" ? "단어" : "문장"}
          </span>
          <span className="text-sm text-gray-600">
            {word_cnt}개
          </span>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-100">
        {is_pre_exist == false &&
          <button className="w-full bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-semibold rounded-lg hover:scale-105 hover:from-teal-600 hover:to-cyan-600 transition-all duration-200 p-4 shadow-md hover:shadow-lg"
            onClick={() => {
              myProps.go_add_use_by_ajax({
                inside_seq_arr: [info.a_seq]
              });
            }}
          >
            학습하기
          </button>
        }
        {is_pre_exist && use_info.a_text_score < 100 &&
          <div className="bg-gradient-to-r from-orange-50 to-orange-100 border border-orange-200 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
                <span className="text-sm font-semibold text-orange-700">학습중</span>
              </div>
              <div className="bg-white px-3 py-1 rounded-full border border-orange-300 shadow-sm">
                <span className="text-sm font-bold text-orange-700">{use_info.a_text_score}%</span>
              </div>
            </div>
          </div>
        }
        {is_pre_exist && use_info.a_text_score >= 100 &&
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-sm font-semibold text-green-700">학습완료</span>
              </div>
              <div className="bg-white px-3 py-1 rounded-full border border-green-300 shadow-sm">
                <span className="text-sm font-bold text-green-700">{use_info.a_text_score}%</span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};
export default RowArea;